import { useState } from "react";

export default function useCustomerPricingModal() {
  const [selectedCustomerForPricing, setSelectedCustomerForPricing] = useState(null);

  const openCustomerPricing = (customer) => {
    setSelectedCustomerForPricing(customer);
  };

  const closeCustomerPricing = () => {
    setSelectedCustomerForPricing(null);
  };

  return {
    closeCustomerPricing,
    openCustomerPricing,
    selectedCustomerForPricing,
    showCustomerPricingForm: Boolean(selectedCustomerForPricing),
  };
}
